<template>
    <form method="POST" v-on:submit.prevent="handleSubmit">
        <div class='m-portlet__body'>
            <Validation :inputs="inputs" v-bind:create-rules="createRules" v-bind:update-rules="updateRules" v-on:createRules='updateCreateRuleData' v-on:updateRules='updateUpdateRuleData'></Validation>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/modules/index`"></Buttons>
    </form>
</template>

<script>
import Validation from '../../core/module/Validation'
import Buttons from '../../core/form/Buttons'
export default {
  name: 'ModuleUpdateValidation',
  components: {Buttons, Validation},
  data () {
    return {
      createRules: [],
      updateRules: [],
      validation: {},
      inputs: {}
    }
  },
  methods: {
    updateCreateRuleData (variable) {
      this.createRules = variable
    },
    updateUpdateRuleData (variable) {
      this.updateRules = variable
    },
    handleSubmit () {
      let create = {}

      for (let it in this.createRules) {
        create[this.createRules[it].key] = []
      }

      for (let it in this.createRules) {
        create[this.createRules[it].key].push(this.createRules[it].value + this.createRules[it].value2)
      }

      this.validation.CREATE = create

      let update = {}

      for (let it in this.updateRules) {
        update[this.updateRules[it].key] = []
      }

      for (let it in this.updateRules) {
        update[this.updateRules[it].key].push(this.updateRules[it].value + this.updateRules[it].value2)
      }

      this.validation.UPDATE = update

      this.$http
        .put(process.env.API_URL + `/api/v1/admin/module-builder/update-validation`, {
          validation: this.validation,
          moduleName: this.$route.params.id
        }, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            this.$router.push('/admin/modules/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  mounted: function () {
    this.$emit('updateTitle', 'Update Validation: ' + this.$route.params.id)

    let self = this
    this.$http
      .get(process.env.API_URL + `/api/v1/admin/module-builder/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.inputs = res.data.data[this.$route.params.id].fillable
        for (let it in res.data.data[this.$route.params.id].validation.create) {
          for (let xit in res.data.data[this.$route.params.id].validation.create[it]) {
            if (res.data.data[this.$route.params.id].validation.create[it][xit].indexOf(':') !== -1) {
              let spl = res.data.data[this.$route.params.id].validation.create[it][xit].splice(':')
              self.createRules.push({key: it, value: spl[0], value2: spl[1]})
            } else {
              self.createRules.push({
                key: it,
                value: res.data.data[this.$route.params.id].validation.create[it][xit],
                value2: ''
              })
            }
          }
        }

        for (let it in res.data.data[this.$route.params.id].validation.update) {
          for (let xit in res.data.data[this.$route.params.id].validation.update[it]) {
            if (res.data.data[this.$route.params.id].validation.update[it][xit].indexOf(':') !== -1) {
              let spl = res.data.data[this.$route.params.id].validation.update[it][xit].splice(':')
              self.updateRules.push({key: it, value: spl[0], value2: spl[1]})
            } else {
              self.updateRules.push({
                key: it,
                value: res.data.data[this.$route.params.id].validation.update[it][xit],
                value2: ''
              })
            }
          }
        }
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/module/ModuleUpdateValidation.vue